import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, Directive, inject, input, TemplateRef } from '@angular/core';
import { injectHeadingLevel } from '@storyteller/core';
//title directive which can be used to set the heading level
@Directive({
    selector: 'ng-template[storyTitle]',
})
export class StoryTitleDirective {
    public template = inject(TemplateRef<never>);
}

// card component
@Component({
    selector: 'story-title',
    template: `
        @switch (htmlTag()) {
            @case (1) {
                <h1 [class]="className() ?? 'story-font-display3'">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </h1>
            }
            @case (2) {
                <h2 [class]="className() ?? 'story-font-headline1'">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </h2>
            }
            @case (3) {
                <h3 [class]="className() ?? 'story-font-headline2'">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </h3>
            }
            @case (4) {
                <h4 [class]="className() ?? 'story-font-headline3'">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </h4>
            }
            @case (5) {
                <h5 [class]="className() ?? 'story-font-headline4'">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </h5>
            }

            @default {
                <h1 class="aui-font-regular-14">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </h1>
            }
        }

        <ng-template #content>
            <ng-content></ng-content>
        </ng-template>
    `,
    imports: [NgTemplateOutlet],
    styles: [
        `
            :host {
                @apply block;
            }
        `,
    ],
})
export class StoryTitleComponent {
    injectHeadingLevel = injectHeadingLevel();
    headingLevel = input<number | undefined>(undefined);
    htmlTag = computed(() => this.headingLevel() ?? this.injectHeadingLevel());
    paddingBottom = input<boolean | undefined>(true);
    className = input<string | undefined>(undefined);
}
